// extracted by mini-css-extract-plugin
module.exports = {"h1":"confirmation_h1__317xm","largeBtn":"confirmation_largeBtn__C7_aL","btnText":"confirmation_btnText__2iboX"};